import React, { useContext, useEffect, useRef } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom';
import { Button, ConfirmDialog, Dialog, TabPanel, TabView, Toast, confirmDialog } from 'primereact';


import Card from '../../../Base/Components/Card/Card'
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { toastShow } from '../../../Base/Services/ToastService';


import { cancelVisita, getVisitaDetalle, getVisitasDate } from '../../../API/Logistica/Visitas/VisitasRequests';
import ProgramacionVisitasCrud from './ProgramacionVisitasCrud';
import QRVisitas from './QR/QRVisitas';
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek';
import { getDatesProduccion } from '../../../Base/Services/Moment/Luxon';

// import './../../../styles/PPF_dark.scss'
import { getVisitasDetalleDate } from '../../../API/Logistica/Visitas/VisitaDetallesRequests';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import { setTitlePage } from '../../../Base/Services/Config/ConfigService';

const ProgramacionVisitasScreen = () => {

    const toast = useRef(null);

    const { userAuth } = useContext(AuthContext);

    let { token } = useParams();
    if (!token) {
        token = localStorage.getItem('TokenPPF');
    }

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [detalle, setDetalle] = useState([]);
    const [showDialogEdit, setShowDialogEdit] = useState(false);
    const [visitaEdit, setVisitaEdit] = useState(null);
    const [showQR, setShowQR] = useState(null);
    const [dates, setDates] = useState([new Date(), new Date()])

    const getInfo = async () => {
        setLoading(true);
        if (dates.length === 2) {
            const fechas = getDatesProduccion(dates);
            if (fechas.fecha1 && fechas.fecha2) {
                const e = await getVisitasDate(fechas, token);
                const d = await getVisitasDetalleDate(fechas, token);
                setData(e);
                setDetalle(d);
            } else {
                toastShow(toast, 'warn', 'Advertencia', 'Seleccione un rango de fechas');
            }
        }
        setLoading(false);
    }

    const onEdit = async (NoVisita = null) => {
        if (NoVisita) {
            setShowDialogEdit(true);
            const t = await getVisitaDetalle(NoVisita, token);
            if (t.length > 0) {
                setVisitaEdit({
                    ...t[0],
                    FechaProgramada: new Date(t[0].FechaProgramada),
                    FechaVencimiento: new Date(t[0].FechaVencimiento),
                });
            } else {
                toastShow('warn', 'Advertencia', 'No se encontró la visita');
            }
        } else {
            setVisitaEdit(null);
            setShowDialogEdit(true);
        }
    }

    const onHide = () => {
        setShowDialogEdit(false);
        getInfo();
    }

    const cancelarVisita = async (rowData) => {
        confirmDialog({
            message: `¿Está seguro que desea cancelar la visita ${rowData?.Motivo}?`,
            header: `Cancelar ${rowData?.NoVisita}`,
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                setLoading(true);
                await cancelVisita(rowData, token);
                getInfo();
                setLoading(false);
            },
            reject: () => { }
        })
    }

    const Botones = (rowData) => {
        if (!rowData?.IdVisitaEnc) return <div></div>;
        return <div className='d-flex' style={{ gap: 10 }}>
            <Button icon={'pi pi-pencil'} className='p-button-success p-button-text' style={{ height: '1.5rem' }} onClick={() => onEdit(rowData.NoVisita)} />
            <Button icon={'pi pi-qrcode'} className='p-button-text' style={{ height: '1.5rem' }} onClick={e => setShowQR(rowData)} />
            <Button icon={'pi pi-trash'} className='p-button-danger p-button-text' style={{ height: '1.5rem' }} onClick={() => cancelarVisita(rowData)} />
        </div>
    }

    const colums = [
        {
            header: 'ID',
            field: 'IdVisitaEnc',
            className: 'XXsmall',
            onCellDoubleClicked: (rowData) => {
                if(rowData?.data?.NoVisita){
                    onEdit(rowData?.data?.NoVisita) 
                }
            },
        },
        {
            header: 'No Visita',
            field: 'NoVisita',
            className: 'small',
            Format: 'Modal',
            onCellDoubleClicked: (rowData) => {
                if(rowData?.data?.NoVisita){
                    onEdit(rowData?.data?.NoVisita) 
                }
            },
        },
        {
            header: 'Fecha',
            field: 'FechaProgramada',
            Format: 'Date',
            onCellDoubleClicked: (rowData) => {
                if(rowData?.data?.NoVisita){
                    onEdit(rowData?.data?.NoVisita) 
                }
            },
        },
        {
            header: 'Motivo',
            field: 'Motivo',
            Sumary: 'count',
            flex: 1,
            minWidth: 200,
            onCellDoubleClicked: (rowData) => {
                if(rowData?.data?.NoVisita){
                    onEdit(rowData?.data?.NoVisita) 
                }
            },
        },
        {
            header: 'AreaSolicita',
            field: 'AreaSolicita',
            onCellDoubleClicked: (rowData) => {
                if(rowData?.data?.NoVisita){
                    onEdit(rowData?.data?.NoVisita) 
                }
            },
        },
        {
            header: 'Solicita',
            field: 'UsuarioSolicita',
            onCellDoubleClicked: (rowData) => {
                if(rowData?.data?.NoVisita){
                    onEdit(rowData?.data?.NoVisita) 
                }
            },
        },
        {
            header: 'Vencimiento',
            handerEn: 'Expiration',
            field: 'FechaVencimiento',
            className: '',
            Format: 'Date',
            onCellDoubleClicked: (rowData) => {
                if(rowData?.data?.NoVisita){
                    onEdit(rowData?.data?.NoVisita) 
                } 
            },
        },
        
        {
            header: 'Abierta',
            handerEn: 'Open',
            field: 'VisitaAbierta',
            className: 'Xsmall',
        },
        {
            header: 'Permanente',
            handerEn: 'Permanent',
            field: 'VisitaPermanente',
            className: 'Xsmall',
        },
        
        
        {
            header: '',
            field: 'Botones',
            Format: 'Template',
            body: Botones,
        },

    ];

    const tableVisita = {
        Columns: colums,
        Data: data,
        loading: loading,
        showModal: e => {},
    }

    const columnsDetalle = [
        {
            header: 'ID',
            field: 'IdVisitaDetalle',
            className: 'XXsmall',
            onCellDoubleClicked: (rowData) => {
                if(rowData?.data?.NoVisita){
                    onEdit(rowData?.data?.NoVisita) 
                }
            },
        },
        {
            header: 'No Visita',
            field: 'NoVisita',
            className: 'small',
            Format: 'Modal',
            onCellDoubleClicked: (rowData) => {
                if(rowData?.data?.NoVisita){
                    onEdit(rowData?.data?.NoVisita) 
                }
            },
            Sumary: 'count'
        },
        {
            header: 'Nombre visita',
            field: 'NombreVisita',
            className: 'Xlarge'
        },
        {
            header: 'Motivo',
            field: 'Motivo',
            Sumary: 'XXcount',
            classNameL: 'large',
        },
        {
            header: 'Fecha',
            field: 'FechaProgramada',
            Format: 'Date'
        },
        {
            header: 'Ingreso',
            field: 'HoraIngreso',
            className: 'Xsmall',
        },
        {
            header: 'Salida',
            field: 'HoraSalida',
            className: 'Xsmall',
        },
        {
            header: 'Area',
            field: 'AreaSolicita',
        },
        {
            header: 'Solicita',
            field: 'UsuarioSolicita',
        },
    ];

    const tableDetalle = {
        Columns: columnsDetalle,
        Data: detalle,
        loading: loading,
        showModal: e => {},
    }


    useEffect(() => {
        getInfo();
        setTitlePage('Visitas');
        // agregar clase css dark a tag html con js
        // document.documentElement.classList.add('Dark');

    }, [])


    return (
        <div className='dark'>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Card
                titulo={<div className='botones d-flex gap'>
                    <h3>Programación de visitas</h3>
                    <CalendarWeek
                        date={dates}
                        setDate={setDates}
                        buscar={getInfo}
                        loading={loading}
                        selectionMode='range'
                        // view='month'
                        dateFormat='dd/mm/yy'
                    />
                    {/* <Button icon={'pi pi-search'} onClick={getInfo} /> */}
                    <Button icon={'pi pi-plus'} className='p-button-success' onClick={e => onEdit()} />
                </div>}
                contenido={<div className='pt-4' style={{ height: '90vh' }}>
                    <TabView>
                        <TabPanel header='Visitas'>
                            <div style={{ height: '83vh' }}>
                                <AgGrid table={tableVisita} />
                            </div>
                        </TabPanel>
                        <TabPanel header='Detalle'>
                            <div style={{ height: '83vh' }}>
                                <AgGrid table={tableDetalle} />
                            </div>
                        </TabPanel>
                    </TabView>
                </div>}
            />
            <ProgramacionVisitasCrud
                showDialogEdit={showDialogEdit}
                onHide={onHide}
                key={visitaEdit}
                visitaEdit={visitaEdit}
                onEdit={onEdit}
            />
            <Dialog visible={true && showQR?.IdVisitaEnc} onHide={() => setShowQR(null)}>
                <QRVisitas
                    show={showQR}
                    onHide={() => setShowQR(null)}
                />
            </Dialog>

        </div>
    )
}

export default ProgramacionVisitasScreen